// Handle ResizeObserver warnings
const resizeObserverHandler = () => {
  const originalError = window.console.error;
  window.console.error = (...args) => {
    if (args[0]?.includes?.("ResizeObserver loop")) {
      return;
    }
    originalError.apply(window.console, args);
  };
};

export default resizeObserverHandler;
